module.exports = __webpack_public_path__ + "img/position@2x.99122011.png";